export const scope = 'app-containers-MaterialsPage';
const DownloadItemScope = 'app-components-DownloadItem';

const messages = {
  materials: `${scope}-materials`,
  yes: `${scope}-yes`,
  no: `${scope}-no`,
  necessary: `${scope}-necessary`,
  not_recommended: `${scope}-not_recommended`,
  recommended: `${scope}-recommended`,
  yes_stick_glue: `${scope}-yes_stick_glue`,
  yes_enclosure: `${scope}-yes_with_enclosure`,
  yes_tape: `${scope}-yes_tape`,
  yes_window_cleaner: `${scope}-yes_window_cleaner`,
  yes_magigoo_ht: `${scope}-yes_magigoo_ht`,
  toluene: `${scope}-toluene`,
  acetone: `${scope}-acetone`,
  benzene: `${scope}-benzene`,
  water: `${scope}-water`,
  chloroform: `${scope}-chloroform`,
  acetaldehyde: `${scope}-acetaldehyde`,
  limonene: `${scope}-limonene`,
  edc: `${scope}-edc`,
  thf: `${scope}-thf`,
  dcm: `${scope}-dcm`,
  // Headers + tooltips
  material: `${scope}-material`,
  materialTooltip: `${scope}-materialTooltip`,
  texturedSheet: `${scope}-texturedSheet`,
  texturedSheetTooltip: `${scope}-texturedSheetTooltip`,
  ppSheet: `${scope}-ppSheet`,
  smoothSheet: `${scope}-smoothSheet`,
  smoothSheetTooltip: `${scope}-smoothSheetTooltip`,
  satinSheet: `${scope}-satinSheet`,
  nylonSheet: `${scope}-nylonSheet`,
  yes_cleaned_with_water: `${scope}-yes_cleaned_with_water`,
  enclosure: `${scope}-enclosure`,
  enclosureTooltip: `${scope}-enclosureTooltip`,
  hardenedNozzle: `${scope}-hardenedNozzle`,
  hardenedNozzleTooltip: `${scope}-hardenedNozzleTooltip`,
  solvents: `${scope}-solvents`,
  solventsTooltip: `${scope}-solventsTooltip`,
  warping: `${scope}-warping`,
  warpingTooltip: `${scope}-warpingTooltip`,
  price: `${scope}-price`,
  priceTooltip: `${scope}-priceTooltip`,
  nozzleTemp: `${scope}-nozzleTemp`,
  nozzleTempTooltip: `${scope}-nozzleTempTooltip`,
  bedTemp: `${scope}-bedTemp`,
  bedTempTooltip: `${scope}-bedTempTooltip`,
  printingSpeed: `${scope}-printingSpeed`,
  heatDeflection: `${scope}-heatDeflection`,
  heatDeflectionTooltip: `${scope}-heatDeflectionTooltip`,
  impactToughness: `${scope}-impactToughness`,
  impactToughnessTooltip: `${scope}-impactToughnessTooltip`,
  yieldStrength: `${scope}-yieldStrength`,
  yieldStrengthTooltip: `${scope}-yieldStrengthTooltip`,
  // Tags
  foodsafe: `${scope}-foodsafe`,
  suitableForTinyParts: `${scope}-suitableForTinyParts`,
  lowWarping: `${scope}-lowWarping`,
  highTenacity: `${scope}-highTenacity`,
  heatbedNotRequired: `${scope}-heatbedNotRequired`,
  composite: `${scope}-composite`,
  impactResistance: `${scope}-impactResistance`,
  chemicalResistance: `${scope}-chemicalResistance`,
  suitableForMechanicalParts: `${scope}-suitableForMechanicalParts`,
  dissolvable: `${scope}-dissolvable`,
  temperatureResistance: `${scope}-temperatureResistance`,
  uvResistance: `${scope}-uvResistance`,
  flexibleOrBendable: `${scope}-flexibleOrBendable`,
  supportMaterial: `${scope}-supportMaterial`,
  staticText: `${scope}-staticText`,
  staticTextBlogLink: `${scope}-staticTextBlogLink`,
  dryBox: `${scope}-dryBox`,
  dryBoxTooltip: `${scope}-dryBoxTooltip`,
  all: `${scope}-all`,
  moreInfo: `${DownloadItemScope}-moreInfo`,
  firstLayer: `${scope}-firstLayer`,
};

export default messages;
